import { Link as MUILink } from "@mui/material";
import { createLink } from "@tanstack/react-router";

const Link = createLink(MUILink);

export default Link;
